<template>
  <div class="v-tariff-table">
    <v-tariff-create-update-form v-if="this.isShowModal" :tariff-id="this.tariffId"
                                 @close="closeModal" />
    <table v-else class="table">
      <thead>
        <tr>
          <th scope="col">Тариф</th>
          <th v-if="role === 'administrator' || role === 'employee'" scope="col">
            Внутренне имя
          </th>
          <th v-if="role === 'administrator' || role === 'employee'" scope="col">Дилеры</th>
          <th v-else-if="role === 'dealer'" scope="col">Комиссия</th>
          <th scope="col">Цена</th>
          <th scope="col">Статус</th>
          <th v-if="role === 'administrator' || role === 'employee'" scope="col">
            Изм. дата
          </th>
          <th v-if="role === 'administrator'" scope="col"></th>
          <th v-if="role === 'administrator'" scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tariff in this.tariffList" :key="tariff.id">
          <th scope="row">{{ tariff.name }}</th>
          <td v-if="role === 'administrator' || role === 'employee'">
            {{ tariff.internal_name }}
          </td>
          <td v-else-if="role === 'dealer'">{{ tariff.dealer_fee }} &#8381;</td>
          <td v-if="role === 'administrator' || role === 'employee'">
            {{ tariff.dealers.length}}
          </td>
          <td>
            {{ calculateSubscriptionPrice(tariff.dealer_fee, tariff.service_fee, tariff.price) }}
             &#8381;
          </td>
          <td>{{ tariff.is_active ? 'Активен' : 'Не активен' }}</td>
          <td v-if="role === 'administrator'">
            {{ tariff.is_variable_payment_date ? 'Да' : 'Нет' }}
          </td>
          <td v-if="role === 'administrator'" @click="showModal(tariff.id)">
            <font-awesome-icon :icon="['fa', 'cogs']"/>
          </td>
          <td v-if="role === 'administrator'" @click="deleteTariff(tariff.id)">
            <font-awesome-icon :icon="['fa', 'trash']"/>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import VTariffCreateUpdateForm from '../forms/v-tariff-create-update-form.vue';

export default {
  name: 'v-tariff-table',
  components: { VTariffCreateUpdateForm },
  props: ['tariffList', 'role'],
  data() {
    return {
      isShowModal: false,
      tariffId: '',
    };
  },
  methods: {
    deleteTariff(id) {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы действительно хотите удалить этот тариф? В случае удаления тарифа, '
          + 'все абоненты с этим тарифим будут деактивированы!',
        buttons: [
          {
            title: 'Удалить тариф',
            handler: () => {
              this.$store.dispatch('tariff/deleteTariff', id)
                .then(() => {
                  this.$emit('update');
                  this.$modal.hide('dialog');
                });
            },
          },
          {
            title: 'Закрыть',
            default: true,
          },
        ],
      });
    },
    calculateSubscriptionPrice(price, dealerFee, serviceFee) {
      const p = parseFloat(price);
      const df = parseFloat(dealerFee);
      const sf = parseFloat(serviceFee);
      return p + df + sf;
    },
    showModal(tariffId) {
      this.tariffId = tariffId;
      this.isShowModal = true;
    },
    closeModal() {
      this.isShowModal = false;
      this.$emit('update');
    },
  },
};

</script>
